module.exports = {"370115001":"济阳街道","370115002":"济北街道","370115003":"崔寨街道","370115004":"孙耿街道","370115005":"回河街道","370115006":"太平街道","370115101":"垛石镇","370115103":"曲堤镇","370115104":"仁风镇","370115110":"新市镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370115.json
// module id = 1358
// module chunks = 0